module.exports = __webpack_public_path__ + "static/media/video_image2.06966887.png";